import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48387016"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "zone-select-container"
}
const _hoisted_2 = { class: "divider" }
const _hoisted_3 = { class: "divider-text" }
const _hoisted_4 = { class: "label" }

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import CompanyApi from '@/api/CompanyApi'
import { ICompany } from '@/api/CompanyApi/types'
import ZoneApi from '@/api/ZoneApi'
import { IZone } from '@/api/ZoneApi/types'
import QrScanner from './QrScanner.vue'
import Select from '@/components/Select/Select.vue'
import { scopedTranslation } from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  scannerTitle: {
    type: String,
    required: true,
  },
  selectTitle: {
    type: String,
    required: false,
  },
},
  emits: ['zoneFetched'],
  setup(__props, { emit }) {

const props = __props

const { sT } = scopedTranslation('newOrder')





const router = useRouter()
const currentCompanyUuid = router.currentRoute.value.query.companyUuid as string
const loading = ref(true)
const zoneIdentifier = ref('')
const zonesForCompany = ref<IZone[] | undefined>([])
const companySettings = ref<ICompany['settings'] | undefined>(undefined)

const zoneOptions = computed(() => {
  return zonesForCompany.value?.map(zone => ({
    label: zone?.name,
    value: zone?.identifier?.value,
  }))
})

const disableDropdown = computed(() => {
  return companySettings.value?.disable_location_dropdown_in_order_app
})

const setIdentifier = (value: string) => {
  zoneIdentifier.value = value
  emit('zoneFetched', value)
}

onMounted(async () => {
  const company = await CompanyApi.get(currentCompanyUuid)
  companySettings.value = company?.settings
  zonesForCompany.value = await ZoneApi.getAllForCompany(currentCompanyUuid)
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QrScanner, {
      title: props.scannerTitle,
      onIdFound: setIdentifier
    }, null, 8, ["title"]),
    (!_unref(disableDropdown))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(sT)('selectAlternative')), 1)
          ]),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(props.selectTitle), 1),
          _createVNode(Select, {
            modelValue: zoneIdentifier.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((zoneIdentifier).value = $event)),
              setIdentifier
            ],
            options: _unref(zoneOptions)
          }, null, 8, ["modelValue", "options"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})